import HomeCarousel from "./home-carousel";

export default HomeCarousel;